import * as React from "react";
import { Outlet } from "react-router";

export const AuthLayout: React.FC = () => (
  <div className="flex min-h-screen flex-col justify-center bg-ui-app-background py-12 sm:px-6 lg:px-8">
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <div className="flex justify-center">
        <img src="/images/pathfinder_logo_beta.svg" alt="Pathfinder logo" width={200} height={200} />
      </div>
    </div>

    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div className="bg-ui-card-background px-4 py-8 shadow sm:rounded-lg sm:px-10">
        <Outlet />
      </div>
    </div>
  </div>
);
